import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/Login/Login'
import PasswordLogin from '@/pages/Login/PasswordLogin'
import ProcessModeling from '@/pages/ProcessModeling/ProcessModelingPage'
import ProcessReview from "@/pages/ProcessModeling/Review/ProcessReviewPage.vue"
import ShareProcessModeling from '@/pages/ProcessModeling/Share/ShareProcessModeling'
import HomePage from '@/pages/HomePage/HomePage'
import SupportPage from '@/pages/HomePage/SupportPage'
import DashboardPage from "@/pages/Dashboard/DashboardPage";
import ProcessList from "@/pages/ProcessList/ProcessList";
import FolderList from "@/pages/ProcessList/FolderList";
import ResultDashboard from "@/pages/Dashboard/ResultDashboard";

import ContextItemOverview from "@/pages/ProcessMap/MapContextItems/ContextItemOverview.vue";
import ProcessMap from "@/pages/ProcessMap/ProcessMap";
import ProcessMapPage from "@/pages/ProcessMap/ProcessMapPage";
import ProcessMapOverview from "@/pages/ProcessMap/ProcessMapOverview";

import AnswerModelingQuestions from "@/pages/AnswerModelingQuestions/AnswerQuestionsPage";
import PXQuestionsPage from "@/pages/PxQuestionSurvey/PXQuestionsPage/PXQuestionsPage"
import PXCreateQuestionPage from "@/pages/PxQuestionSurvey/PXQuestionsPage/PXCreateQuestionPage"
import PXQuestionOverviewPage from "@/pages/PxQuestionSurvey/PXQuestionsPage/PXQuestionOverviewPage"

import PXSurveyPage from "@/pages/PxQuestionSurvey/PXSurveyPage/PXSurveyPage"
import PXSurveyOverviewPage from "@/pages/PxQuestionSurvey/PXSurveyPage/PXSurveyOverviewPage"
import PXSurveyEvaluationPage from "@/pages/PxQuestionSurvey/PXSurveyPage//Evaluation/PXSurveyEvaluationPage.vue"
import Analytics from "@/pages/PxQuestionSurvey/PXSurveyPage//Evaluation/Analytics.vue"
import PXCreateSurveyPage from "@/pages/PxQuestionSurvey/PXSurveyPage/PXCreateSurveyPage"
import PXSurveyPreviewPage from "@/pages/PxQuestionSurvey/PXSurveyPage/PXSurveyPreviewPage"
import PxResendSurvey from "@/pages/PxQuestionSurvey/PXSurveyPage/PxResendSurvey"

import PxQuestionSurveyPage from "@/pages/PxQuestionSurvey/ProcessExperiencePage"

import UserPanel from "@/pages/UserManagement/UserPanel"
import RolePanel from "@/pages/UserManagement/RolePanel"
import ClientPanel from "@/pages/UserManagement/ClientPanel"
import ClientManagementPanel from "@/pages/UserManagement/ClientManagementPanel"
import OverviewPage from "@/pages/UserManagement/OverviewPage"
import ManagementPage from "@/pages/UserManagement/ManagementPage"

import ChecklistOverview from "@/pages/Innovationprocess/ChecklistOverview"
import ChecklistTitlePage from "@/pages/Innovationprocess/ChecklistTitlePage"
import ChecklistPage from "@/pages/Innovationprocess/ChecklistPage"
import StepperPage from "@/pages/Innovationprocess/StepperPage"
import ChecklistFinishedPage from "@/pages/Innovationprocess/ChecklistFinishedPage"

import PXSurveyProcessPreviewPage from "@/pages/ProcessModeling/Menu/PxQuestionSection/PXSurveyProcessPreviewPage"
import ErrorPage from "@/components/common/ErrorPage.vue"
import PageNotFound from "@/components/common/PageNotFound.vue"
import store from "./store"

Vue.use(Router);

const router = new Router({
    base: process.env.BASE_URL,
    routes: [
        { path: '/', component: Login},
        { path: '/tokenAuth/:authToken', component: PasswordLogin, props:true},
        {
            path: '/menu', name:"home", component: HomePage,
            children: [
                
                { path: '/', components: { model: ResultDashboard } },
                { path: '/404', components: { model: PageNotFound } },
                { path: '/error/:errorCode', components: { model: ErrorPage } },
                { path: '/help', components: { model: SupportPage } },
                { path: '/processList', 
                    components: { model: FolderList },
                    beforeEnter: async (to, from, next) => {
                        let processAccess = await checkProcess();
                        let adminAccess = await checkAdmin();
                        if(processAccess || adminAccess) {
                            next()
                        }else{
                            next({ path: '/error/403' })
                        }                        
                    }, 
                },
                { path: '/processMap', name: 'processMap', components: { model: ProcessMapPage },
                children:[
                    { path: '/', name: 'processMap', components: { map: ProcessMap} },
                    { path: '/processCharacteristic', name:'processCharacteristic', components: { map: ProcessMapOverview} },
                    { path: '/contextItems', components: { map: ContextItemOverview} },
                 ] },
                { path: '/modelEdit/:uuid', name: 'modeling', components: { model: ProcessModeling }, props:true },
                { path: '/modelReview/:uuid', name: 'review', components: { model: ProcessReview }, props:true },
                { path: '/pxAdmin', components: { model: PxQuestionSurveyPage} },
                { path: '/questions',components: { model: PXQuestionsPage},
                    children:[
                        { path: '/', components: { question: AnswerModelingQuestions} },
                        { path: '/modelQuestions', components: { question: AnswerModelingQuestions} },
                        { path: '/manageQuestions', components: { question: PXQuestionOverviewPage} },
                        { path: '/createPXQuestion', components: { question: PXCreateQuestionPage} }
                    ] 
                },
                { path: '/surveys', components: { model: PXSurveyPage} ,
                    children:[
                        { path: '/', components: { survey: PXSurveyOverviewPage} },
                        { path: '/create/:mode', name: 'createSurvey', components: { survey: PXCreateSurveyPage}, props: true },
                        { path: '/send', name: 'resendSurvey', components: { survey: PxResendSurvey}, props: true },
                        { path: '/generated', name:'generatedSurvey', components: { survey: PXSurveyPreviewPage}, props: true },
                        { path: '/processSurvey', name:'processSurvey', components: { survey: PXSurveyProcessPreviewPage}, props: true },
                        { path: '/evaluation/:surveyId', name: 'evaluateSurvey', components: {survey: PXSurveyEvaluationPage}},
                        { path: '/evaluation/custom/:surveyId', name: 'evaluateCustomSurvey', components: {survey: Analytics}}
                    ],
                    beforeEnter: async (to, from, next) => {
                        let surveyAccess = await checkSurvey();
                        let adminAccess = await checkAdmin();
                        if(surveyAccess || adminAccess) {
                            next()
                        }else{
                            next({ path: '/error/403' })
                        }  
                    },
                },      
                { path: '/checklist', components: { model: ChecklistPage },
                children:[
                    { path: '/', components: { checklist: ChecklistOverview} },
                    { path: '/newChecklist/:listId', name: 'createList', components: { checklist: ChecklistTitlePage}, props: true},
                    { path: '/answerChecklist/:listId', name: 'answerList', components: { checklist: StepperPage}},
                    { path: '/finished/:listId', name: 'finishList', components: { checklist: ChecklistFinishedPage} },
                ] },
                { path: '/management', components: { model: ManagementPage } ,
                children:[
                    { path: '/', components: { management: OverviewPage} },
                    { path: '/users', components: { management: UserPanel } },
                    { path: '/roles', components: { management: RolePanel } },
                    { path: '/clients', components: { management: ClientPanel } },
                    { path: '/externalAPI', components: { management: ClientManagementPanel } }    
                ],
                beforeEnter: async (to, from, next) => {
                    let adminAccess = await checkAdmin();
                    if(adminAccess) {
                        next()
                    }else{
                        next({ path: '/error/403' })
                    } 
                }, },
                      
            ]
        },
        { path: '/modelEdit/:uuid/share/:clientId/:token', component: ShareProcessModeling },
        { path: "*",
            beforeEnter: async (to, from, next) => {
                const isValidRoute = router.resolve(to).resolved.matched.length > 0;
                if(!isValidRoute) next({ path: '/404' })
                next();
    
            
            }
        }

    ]
});
router.beforeEach((to, from, next) => {

    //next();
    if(to.matched.some(record => record.meta.bameroRoute)){
        if(process.env.VUE_APP_BAMERO){
            next();
        }else{
            next({ path: '/menu'})
        }
    }else{
        next();
    } 
});

async function checkAdmin(){
    let userIsAdmin = await store.dispatch('hasPermission', 'ADMIN');
    if(!userIsAdmin) userIsAdmin = await store.dispatch('hasPermission', 'SUPER_ADMIN');
    return userIsAdmin;
}
async function checkProcess(){
    let hasProcessPermission = await store.dispatch('hasPermission', 'PROCESS');
    return hasProcessPermission;
}
async function checkSurvey(){
    let hasSurveyPermission = await store.dispatch('hasPermission', 'SURVEY');
    return hasSurveyPermission;
}
export default router;